import React from 'react';
import Index from './publicComponents/index';
import Bayans from './publicComponents/bayans';
import { Switch, Route } from 'react-router-dom';
import Dua from './publicComponents/dua';
import PublicEvents from './publicComponents/event';
import Contact from './publicComponents/contact';
import Page404 from './publicComponents/pageNotFound';

function App() {
  return (
    <div>
      <Switch>
        <Route exact path='/' component={Index} />
        <Route path='/bayans' component={Bayans} />
        <Route path='/dua' component={Dua} />
        <Route path='/publicEvents' component={PublicEvents} />
        <Route path='/contact' component={Contact} />
        <Route component={Page404} />
      </Switch>
    </div>
  );
}

export default App;
